import styled from "styled-components";
import { Box } from "orcs-design-system";

export const AIMessageWrapper = styled(Box)`
  min-width: 95%;
  max-width: 95%;
`;
